<template>
  <div style="margin-left: 30px;">
    <form>
      <div class="form-control pa-1" :class="{ 'has-error': errors.has('titleName') }">
        <label>{{ $t('Topic Name') }}</label>
        <input
          :data-vv-as="$t('Topic Name')"
          v-validate="'required'"
          v-model="productSelect.titleName"
          name="titleName"
          class="form-control"
          type="text"
        />
        <span class="text-error" v-if="errors.has('titleName')">{{
          errors.first('titleName')
        }}</span>
      </div>
      <!-- <v-radio-group v-model="productSelect.option" color="primary" col class="text-xs-center">
        <v-radio color="primary" :value="'popular'">
          <template slot="label">
            <span> เลือกจากระบบที่มีอยู่แล้ว</span>
          </template>
        </v-radio>
        <v-radio color="primary" :value="'custom'">
          <template slot="label">
            <span> กำหนดเอง</span>
          </template>
        </v-radio>
      </v-radio-group> -->
      <template v-if="productSelect.option === 'custom'">
        <span class="mt-4">{{ $t('Select Product') }}</span>
        <v-flex class="form-control">
          <input type="text" v-model="search" :placeholder="$t('Search')" />
        </v-flex>
        <div style="max-height: 155px; overflow-x: auto;">
          <template v-for="(item, k) in filterProducts">
            <v-checkbox
              :key="`${item.name}_${k}`"
              v-model="productSelect.productSelect"
              :label="item.name"
              color="red"
              :value="item.id"
              hide-details
            ></v-checkbox>
          </template>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  computed: {
    ...mapGetters({
      products: 'getProducts'
    }),
    filterProducts: function() {
      const vm = this
      if (vm.search !== '' && vm.products) {
        return vm.products.filter(function(post) {
          return post.name ? post.name.toLowerCase().includes(vm.search.toLowerCase()) : false
        })
      }
      return vm.products
    }
  },
  data() {
    return {
      productSelect: this.value,
      search: ''
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/ProductSelect.vue